import { NgModule } from '@angular/core';
import { formatMinutesPipe } from './format-minutes.pipe';

@NgModule({
   declarations: [formatMinutesPipe],
   exports: [formatMinutesPipe],
})
export class FormatMinutesPipeModule {}
